import { MutationCache, QueryClient, onlineManager } from '@tanstack/react-query'

import { ApiError } from './client'

/** Ключ сводки «Сегодня» (`pages/today/api.ts`): её меняет почти любая запись. */
export const TODAY_QUERY_KEY = ['today'] as const

/** Ошибки 4xx не повторяем: повтор не поможет. Сеть и 5xx — до двух повторов. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false
  return failureCount < 2
}

/** Сводка «Сегодня» устарела — после любой успешной записи (веб или доставка очереди). */
export function invalidateToday(client: QueryClient): Promise<void> {
  return client.invalidateQueries({ queryKey: TODAY_QUERY_KEY })
}

export function createQueryClient(): QueryClient {
  // TanStack Query по умолчанию считает, что сеть есть, пока не придёт событие `offline`.
  // При старте без сети запросы тогда уходят и получают ответ из кэша SW — «данные на» сейчас.
  if (typeof navigator !== 'undefined') onlineManager.setOnline(navigator.onLine)
  const client: QueryClient = new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: () => {
        void invalidateToday(client)
      },
    }),
    defaultOptions: {
      queries: { retry: shouldRetry, staleTime: 30_000 },
      mutations: { retry: false },
    },
  })
  return client
}
